import * as React from 'react';
import { TockProductType } from '@tock/shared/types/productFeatures';
import ProductFeatureRestriction from '@tock/shared/components/product/ProductFeatureRestriction';

type RenderPropFunction = ({ pass }: { pass: boolean }) => React.ReactNode;

export interface Props {
  onlyForProductType?: TockProductType;
  children?: React.ReactNode | RenderPropFunction;
}

const ConsumerProductFeatureRestriction: React.FunctionComponent<Props> = (props: Props) => {
  return (
    <ProductFeatureRestriction onlyForProductType={props.onlyForProductType}>
      {props.children}
    </ProductFeatureRestriction>
  );
};

export default ConsumerProductFeatureRestriction;
